import type { SpeechGenerateParams } from '../base';
import type { KieSunoModelConfig } from './types';
import { kieSunoModelConfigs } from './config';

export function getKieSunoModelConfig(modelId: string): KieSunoModelConfig {
  const cfg = kieSunoModelConfigs[modelId];
  if (!cfg) {
    throw new Error(`Model ${modelId} not found`);
  }
  return cfg;
}

export function buildCreatePayloadFromConfig(
  modelId: string,
  params: SpeechGenerateParams
): Record<string, any> {
  const cfg = getKieSunoModelConfig(modelId);
  const input = cfg.buildInput({
    text: params.text,
    voice: params.voice,
    providerOptions: params.providerOptions,
  });
  return {
    ...input,
  };
}